export default [
    {
        path: "/training/ipft/list",
        component: () => import("../Components/List.vue"),
        name: "training-ipft-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/ipft/create",
        component: () => import("../Components/Create.vue"),
        name: "training-ipft-create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/ipft/detail-list",
        component: () => import("../Components/DetailList.vue"),
        name: "training-ipft-detail-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/ipft/detail",
        component: () => import("../Components/DetailCreate.vue"),
        name: "training-ipft-detail",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/ipft/detail-edit/:id",
        component: () => import("../Components/DetailEdit.vue"),
        name: "training-ipft-detail-edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/ipft/result",
        component: () => import("../Components/Result.vue"),
        name: "training-ipft-result",
        meta: {
            requiresAuth: true,
        },
    },
];
